export default __webpack_public_path__ + "f0ccdaca533e9725984c1bdef0089f4a.png";